import { useLoaderData } from "@remix-run/react"
import { useEffect } from "react"

import { loader } from "~/.server/route-container/new-arrivals"
import BannerCarousel from "~/components/banner/BannerCarousel"
import NewProductsGrid from "~/components/search/NewProductsGrid"
import ProductGrid from "~/components/search/ProductGrid"
import { trackEvent, trackScreenView } from "~/firebase.client"
export { loader }

export default function Index() {
  const { result } = useLoaderData<typeof loader>()

  // Firebase tracking
  useEffect(() => {
    // Track screen
    trackScreenView("New Arrivals Page", "NewArrivalsScreen")

    // Track event
    trackEvent("newarrivals_viewed", {
      page: "new-arrivals",
    })
  }, [])
  return (
    <div className="">
      {result.map((item: any, index: number) => (
        <div key={index}>{buildCms(item)}</div>
      ))}
    </div>
  )
}

function buildCms(item: any) {
  if (item.type === "banner") {
    return <BannerCarousel banners={item.children} />
  }
  if (item.type === "collectionProducts") {
    return <ProductGrid collectionSlug={item.id} title={item.title} />
  }
  if (item.type === "grid") {
    return <NewProductsGrid items={item.children} />
  }
}
